import * as React from 'react'
import { observer } from 'mobx-react'
import styles from './CenterOfAttention.sass'
import CallParticipantViewModel from 'messaging/calling/CallParticipantViewModel'
import ParticipantItem from '../ParticipantItem'

interface CenterOfAttentionProps {
  vm: CallParticipantViewModel
}

/**
 * The CenterOfAttention
 */
export default observer(function CenterOfAttention({
  vm,
}: CenterOfAttentionProps) {
  return (
    <div className={styles.root}>
      <ParticipantItem vm={vm} centerOfAttention />
      <div className={styles.centerOfAttentionText}>
        {vm.participant.member.displayName}
      </div>
    </div>
  )
})
